import { createContext, useContext } from "react";

export const DashboardDataContext = createContext({
  queryData: {},
  loading: false,
  error: null,
  parseError: null,
  effectiveCss: "",
  effectiveTemplate: "",
  isEditing: false,
  localCss: "",
  localTemplate: "",
  localQuery: "",
  toggleEdit: () => {},
  reset: () => {},
  setLocalCss: () => {},
  setLocalTemplate: () => {},
  setLocalQuery: () => {},
  activeTab: "template",
  setActiveTab: () => {},
});

export const useDashboardData = () => useContext(DashboardDataContext);
